import { createFileRoute, Outlet } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search'

/** Search lives on the layout so list filters survive navigation to `/accounts/$uuid`. */
export const Route = createFileRoute('/_authed/accounts')({
  validateSearch: listSearchSchema,
  component: () => <Outlet />,
})
